'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

const Header = () => {
  const pathname = usePathname();
  const isHero = pathname === '/';

  const navItems = [
    { href: '/', label: 'Home' },
    { href: '/about', label: 'About' },
    { href: '/discovery', label: 'Discovery' },
    { href: '/for-women', label: 'For Women' },
    { href: '/contact', label: 'Contact' },
  ];

  return (
    <header className={`absolute top-0 left-0 right-0 z-50 ${isHero ? 'bg-transparent' : 'bg-[#f5f2f0]'}`}>
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-5">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#8a7490] rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">F</span>
            </div>
            <div className="flex flex-col">
              <span className={`font-bold text-lg leading-tight ${isHero ? 'text-white' : 'text-[#2b262e]'}`}>
                Female Fitness
              </span>
              <span className={`text-xs leading-tight ${isHero ? 'text-white/80' : 'text-[#6e6672]'}`}>
                Finder
              </span>
            </div>
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className={`text-sm font-medium transition-colors ${
                  pathname === item.href
                    ? isHero ? 'text-white border-b border-white' : 'text-[#8a7490] border-b border-[#8a7490]'
                    : isHero ? 'text-white/90 hover:text-white' : 'text-[#6e6672] hover:text-[#8a7490]'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Right side actions */}
          <div className="flex items-center gap-4">
            <button className={`p-2 rounded-full transition-colors ${isHero ? 'text-white hover:bg-white/10' : 'text-[#6e6672] hover:bg-[#8a7490]/10'}`}>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </button>
            <Link
              href="/register"
              className="px-5 py-2 bg-[#8a7490] text-white text-sm font-medium rounded-lg hover:bg-[#7a647d] transition-colors"
            >
              Register
            </Link>
            <Link
              href="/login"
              className={`text-sm font-medium transition-colors ${isHero ? 'text-white hover:text-white/80' : 'text-[#2b262e] hover:text-[#8a7490]'}`}
            >
              Login
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
